import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { versionKeys } from "@/lib/query";

export function useVersion() {
  return useQuery({
    queryKey: versionKeys.all,
    queryFn: () => apiFetch<{ version: string }>("/version"),
    staleTime: Number.POSITIVE_INFINITY,
  });
}
